import { GOODWILL_CONSTANT } from '../utils/constant';
import { Observable } from 'rxjs';
import { Inject, ChangeDetectorRef } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { FormControl } from '@angular/forms';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import localeEs from '@angular/common/locales/es';
import localeEn from '@angular/common/locales/en';
import { CacheService } from '../services/cache.service';
import { CommonService } from '../services/common.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from '../services/authentication.service';
import { SagaiService } from '../services/sagai.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ElementRef } from '@angular/core';
import { ViewChild } from '@angular/core';
import { Sagai } from '../model/sagai';
//import { Renderer2 } from '@angular/core';

registerLocaleData(localeFr, 'fr');
registerLocaleData(localeEs, 'es');
registerLocaleData(localeEn, 'en');

@Component({
  selector: 'app-root',
  templateUrl: './root.component.html',
  styleUrls: ['./root.component.scss']
})
export class RootComponent implements OnInit {
 @ViewChild('resultsSection') resultsSection!: ElementRef;
  title = 'dmbr-goodwill-ui';
  selected = new FormControl(0);
  isTokenValidated: boolean = false;
  isErrorDetected: boolean = false;
  isAdditionalInfoUpdated: boolean;
  shscrolledcount: number;
  showResults: boolean = false; 
  vin: string = '';
  partReference: string = '';
  currentMileage: string = '';
  unit: string = ''; 
  brand: string = '';
  rrdiCode: string = ''; 
  vinReadOnly: boolean = false;
  brandReadOnly: boolean = true;
  statusRequest: string = 'Pending';
  errorMessage: string = '';
  labourAcknowledged: string = '';  
  materialAcknowledged: string = ''; 
  oktranlation: any;
  cleartranlation: any;
  partReferencePlaceholder: any;
  currentMileagePlaceholder: any;
  vinPlaceholder :any;
  statusRequestColor: string = ''; 
  approvalStatus: string = ''; 
  statusMsg:string='' ;
  sagai: Sagai;
  
  constructor(
    private cacheService: CacheService,
    private commonService: CommonService,
    private toastrService: ToastrService,
    private translationService: TranslateService,
    private authenticationService: AuthenticationService,
    private sagaiService: SagaiService,
    @Inject(DOCUMENT) private document: Document,
    private spinner: NgxSpinnerService,
    private cd: ChangeDetectorRef
  ) {
    translationService.setDefaultLang('en');
    this.shscrolledcount = 0;
  }

  public changeLanguage(langCode: string) {
    this.translationService.use(langCode);
  }

  ngOnInit() {
    this.disableScroll();
    (this.document.body.style as any).msOverflowStyle = 'none'; // For IE and old Edge
    this.translationService.setDefaultLang('en');
    this.spinner.show();
    const token = window.location.href.replace(/^.*[&?]token=?/, '').replace(/&.*$/, '');
    
      if (token === 'null' || token === "") {
          localStorage.clear();
          this.spinner.hide();
          this.translationService.get(['goodwill.i18n.message.token.invalid',
              'goodwill.i18n.validation.message.error'])
              .subscribe(translations => {
                  this.toastrService.warning(
                      translations['goodwill.i18n.message.token.invalid'],
                      translations['goodwill.i18n.validation.message.error'],
                      { timeOut: 5000 }
                  );
              });
          return false; 
      } else {
    this.authenticationService.validateToken(token).then((result: any) => {
      this.changeLanguage(this.cacheService.getItem(GOODWILL_CONSTANT.CACHE_JWT_LANGUAGE));
        
        const brand = this.cacheService.getItem(GOODWILL_CONSTANT.CACHE_JWT_REPAIRER_BRAND);
        const vin = this.cacheService.getItem(GOODWILL_CONSTANT.CACHE_JWT_VIN);
        const rrdiCode = this.cacheService.getItem(GOODWILL_CONSTANT.CACHE_JWT_RRDI);
        
        this.brand = brand || '';
        this.rrdiCode = rrdiCode || '';

        if (vin) {
            this.vin = vin;
            this.vinReadOnly = true;
        }
          
      this.translationService.get([''])
        .subscribe(translations => {
          this.localeInitializer(this.cacheService.getItem(GOODWILL_CONSTANT.CACHE_JWT_LANGUAGE)).then(() => {
            this.oktranlation = this.translationService.instant('goodwill.i18n.button.ok');
        
            this.cleartranlation = this.translationService.instant('goodwill.i18n.button.clear');
        
            this.partReferencePlaceholder = this.translationService.instant('goodwill.i18n.placeholder.partReference');
      
            this.currentMileagePlaceholder = this.translationService.instant('goodwill.i18n.placeholder.currentMileage');
        
            this.vinPlaceholder = this.translationService.instant('goodwill.i18n.placeholder.vin');
            
            console.log('localeInitializer: done');
            this.isTokenValidated = true;
            this.initializeGoodwillAbacusCalculator();
            if (this.vinReadOnly) {
              setTimeout(() => {
                const partReferenceField = document.getElementById('partReference');
                if (partReferenceField) {
                  partReferenceField.focus();
                }
              }, 0);
            } else {
              setTimeout(() => {
                const vinField = document.getElementById('vin');
                if (vinField) {
                  vinField.focus();
                }
              }, 0);
            }
          }).catch(e => {
            console.log(e);
          });
        }, (error: any) => {
          this.translationService.use('en');
          this.translationService.get(['goodwill.i18n.button.ok'])
            .subscribe(translations => {
              this.localeInitializer('en').then(() => {
                this.isTokenValidated = true;
              }).catch(e => {
                console.log(e);
              });
            });
        });
      this.spinner.hide();
    },
      (error: any) => {
        this.isErrorDetected = true;
        localStorage.clear();
        this.spinner.hide();
      });
   }
  }
  disableScroll() {
    this.document.body.style.overflow = 'hidden';
    this.document.documentElement.style.overflow = 'hidden';
  }

  localeInitializer(localeId: string): Promise<any> {
    return import(
      `@angular/common/locales/${localeId}.js`
    ).then(module => registerLocaleData(module.default));
  }
  

  initializeGoodwillAbacusCalculator() {
    const userID = this.cacheService.getItem(GOODWILL_CONSTANT.CACHE_JWT_USER_ID);
  }
  isAlphaNumeric(e: any): boolean {
    try {
        if (/^[a-zA-Z0-9-+\s]*$/.test(e)) {
            return true;
        } else {
            e.preventDefault();
            return false;
        }
    } catch (e) {
    }
  }
  
  isNumeric(value: any): boolean {
  return /^[0-9]+$/.test(value);
} 
  onSubmit(): void {
    if (this.validateGoodwillAbacusCalculator(this.vin, this.partReference, this.currentMileage, this.brand, this.rrdiCode, this.unit)) {
       this.spinner.show(); 
        const startTime = new Date().getTime();  
        this.setSagai();
        this.sagaiService.getDetailsFromSAGAI(this.sagai)
            .subscribe(
                (response: any) => {
                     const endTime = new Date().getTime();  
                     const timeTaken = endTime - startTime;  
                     console.log(`Time taken for API response: ${timeTaken} ms`);
                    this.showResults = true; 
                    this.labourAcknowledged = response.labourRate;
                    this.materialAcknowledged = response.partRate;
                    if ((parseInt(this.labourAcknowledged) > 0 || parseInt(this.materialAcknowledged) > 0) && response.approvalFlag === 'N') {
                        this.statusRequestColor = 'green';
                        this.approvalStatus = '';
                    } else if (this.labourAcknowledged === '0' && this.materialAcknowledged === '0') {
                        this.statusRequestColor = 'red';
                        this.approvalStatus = '';
                    } else if ((parseInt(this.labourAcknowledged) > 0 || parseInt(this.materialAcknowledged) > 0) && response.approvalFlag === 'Y') {
                        this.statusRequestColor = 'yellow';
                        this.approvalStatus = 'Approval Required';
                    }
                    this.resultsSection.nativeElement.style.display = 'block'; 
                    this.cd.detectChanges(); 
                    this.spinner.hide(); 
                },
                (error) => {
                    const endTime = new Date().getTime();  
                    const timeTaken = endTime - startTime;  
                    console.error('Error occurred:', error);
                    console.log(`Time taken for API response (error case): ${timeTaken} ms`);
                    this.spinner.hide();
                    if (error.status === 404 && error.error.message!=null) {
                        this.toastrService.error( 
                            this.translationService.instant(error.error.message),
                            this.translationService.instant('goodwill.i18n.validation.message.error'),
                            { timeOut: 5000 }
                        );
                    }  else if (error.status === 500 && error.error.message !=null) {
                        this.toastrService.error(
                            this.translationService.instant(error.error.message),
                            this.translationService.instant('goodwill.i18n.validation.message.error'),
                            { timeOut: 5000 }
                        );
                    } else if (error.status === 400 && error.error.message !=null) {
                        this.toastrService.error(
                            this.translationService.instant(error.error.message),
                            this.translationService.instant('goodwill.i18n.validation.message.error'),
                            { timeOut: 5000 }
                        );
                    } else {
                        this.toastrService.error(
                            this.translationService.instant(error.error.message),
                            this.translationService.instant('goodwill.i18n.validation.message.error'),
                            { timeOut: 5000 }
                        );
                    }
                    this.statusRequest = '';  
                    this.labourAcknowledged = '0';
                    this.materialAcknowledged = '0';
                    this.statusRequestColor = '';
                    this.approvalStatus = '';
                    this.resultsSection.nativeElement.style.display = 'none'; 
                    this.cd.detectChanges(); 
                }
            );
    }
}

validateGoodwillAbacusCalculator(vin: string, partReference: string, currentMileage: string, brand: string, rrdiCode: string, unit: string): boolean {
  // Check if VIN is null or empty
  if (!vin || vin.trim() === '') {
    this.toastrService.warning(
      this.translationService.instant('goodwill.i18n.validation.vin'),
      this.translationService.instant('goodwill.i18n.validation.message.error'),
      { timeOut: 5000 }
    );
    return false;
  } 
  
  else if (vin.length !== 17) {
    this.toastrService.warning(
      this.translationService.instant('goodwill.i18n.validation.vinLength'),
      this.translationService.instant('goodwill.i18n.validation.message.error'),
      { timeOut: 5000 }
    );
    return false;
  }
  
  else if (!this.isAlphaNumeric(vin)) {
    this.toastrService.warning(
      this.translationService.instant('goodwill.i18n.validation.vinAlphaNumeric'),
      this.translationService.instant('goodwill.i18n.validation.message.error'),
      { timeOut: 5000 }
    );
    return false;
  }
  
  // Check if Part Reference is null or empty
  else if (!partReference || partReference.trim() === '') {
    this.toastrService.warning(
      this.translationService.instant('goodwill.i18n.validation.partReference'),
      this.translationService.instant('goodwill.i18n.validation.message.error'),
      { timeOut: 5000 }
    );
    return false;
  } 
  else if (!this.isAlphaNumeric(partReference)) {
    this.toastrService.warning(
      this.translationService.instant('goodwill.i18n.validation.partReferenceAlphaNumeric'),
      this.translationService.instant('goodwill.i18n.validation.message.error'),
      { timeOut: 5000 }
    );
    return false;
  }  
  else if (!currentMileage || currentMileage.trim() === '') {
    this.toastrService.warning(
      this.translationService.instant('goodwill.i18n.validation.currentMileage'),
      this.translationService.instant('goodwill.i18n.validation.message.error'),
      { timeOut: 5000 }
    );
    return false;
  } 
  
  else if (parseInt(currentMileage) <= 0) {
    this.toastrService.warning(
      this.translationService.instant('goodwill.i18n.validation.currentMileagePositive'),
      this.translationService.instant('goodwill.i18n.validation.message.error'),
      { timeOut: 5000 }
    );
    return false;
  }
  
  else if (!this.isNumeric(currentMileage)) {
    this.toastrService.warning(
      this.translationService.instant('goodwill.i18n.validation.currentMileageNumeric'),
      this.translationService.instant('goodwill.i18n.validation.message.error'),
      { timeOut: 5000 }
    );
    return false;
  }
  else if (!unit || (unit !== 'KM' && unit !== 'MLS')) {
    this.toastrService.warning(
      this.translationService.instant('goodwill.i18n.validation.unit'),
      this.translationService.instant('goodwill.i18n.validation.message.error'),
      { timeOut: 5000 }
    );
    return false;
  } 
  else {
    return true;
  }
  this.showResults = false; 
}

    clearForm(): void {
        if (!this.vinReadOnly) {
            this.vin = '';
        }
        this.partReference = '';
        this.currentMileage = '';
        this.unit = '';
        this.rrdiCode = '';
        this.statusRequest = 'Pending';
        this.statusRequestColor = '';
        this.approvalStatus = '';
        this.showResults = false; 
        this.resultsSection.nativeElement.style.display = 'none'; 
        this.errorMessage = ''; 
        this.showResults = false; 
    }
 
  restrictSpecialChars(event: any): void {
  // Regex to match allowed characters: A-Z, a-z, 0-9
  const regex = /^[A-Za-z0-9]+$/;
  const input = event.target.value;

  if (!regex.test(input)) {
    // If the input contains special characters, prevent the input
    event.target.value = input.replace(/[^A-Za-z0-9]/g, ''); 
  }
}

restrictNumbers(event: any): void {
  // Regex to match allowed characters: 0-9
  const regex = /^[0-9]+$/;
  const input = event.target.value;

  if (!regex.test(input)) {
    // If the input contains any non-numeric characters, prevent the input
    event.target.value = input.replace(/[^0-9]/g, ''); 
  }
}


setSagai(){
    this.sagai = {
      vin:  this.vin,
      mileage: Number(this.currentMileage),
      unit: this.unit,
      partReference: this.partReference,
      rrdiCode: this.rrdiCode,
      brand: this.brand      
       
    }
  }

}